import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const OrderDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 20rem);
    overflow-y: scroll;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 15px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 7rem;
    }
    ${media.mobileDevice`
    padding: 6px;
    //background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    `}
`;

export const MainDiv = styled.div`
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin: 15px 8px 15px 4px;
    ${media.mobileDevice`
        margin: 15px 10px;
    `}
`;

export const Heading = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
    opacity: 1;
    padding: 20px 0 0 20px;
    ${media.mobileDevice`
    font-size: 14px;
    `}

    &.otherSalesAssignments {
        ${media.mobileDevice`
    font-size: 13px;
    padding-bottom: 10.5px;
    display:block;
    `}
    }
`;

export const SubHeading = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 13px;
    opacity: 1;

    &.role {
        ${media.mobileDevice`
        padding-bottom: 8px;
        font-size: 14px;
        `}
    }
`;

export const Container2 = styled(Grid)`
    & .p-dropdown-label {
        margin-right: 32px !important;
    }
    
    ${media.mobileDevice`
    background-color: white;
    font-size: 14px;
    `}
`;

export const Box = styled.div`
    padding: 20px 20px 0 22px;
`;

export const RoleBox = styled.div`
    padding: 20px;
`;
export const ButtonDiv = styled.div`
    justify-content: flex-end;
    display: flex;
    padding: 20px 11px 24px 0px;
`;

export const SalesMainDiv = styled.div`
    justify-content: space-between;
    display: flex;
    padding: 10px 0 5px 20px;

    &.otherSalesDiv {
        ${media.mobileDevice`
        padding: 0px 0 10px 20px;
        `}
    }
`;

export const Unassigned = styled.div`
    font-size: 15px;
    display: flex;
    font-family: AvenirNextWorld Regular;
    text-align: left;
    color: #ef162b;
    opacity: 1;
    line-height: 1.5rem;
    letter-spacing: 0px;
    margin: 12px;
    ${media.mobileDevice`
    display:flex;
    margin:12px;
    line-height:1.5rem;
    `}
`;

export const SalesDiv = styled.div`
    font-size: 15px;
    display: block;
    font-family: AvenirNextWorld Regular;
    text-align: left;
    color: #000000;
    opacity: 0.6;
    text-decoration: ${(props) =>
        props.strikeThru ? 'line-through' : 'unset'};
    word-break: break-all;
`;
export const SalesDivAssignment = styled.div`
    font-size: 15px;
    display: block;
    font-family: AvenirNextWorld Regular;
    text-align: left;
    color: #000000;
    opacity: 0.6;
    text-decoration: ${(props) =>
        props.strikeThru ? 'line-through' : 'unset'};
    word-break: break-all;
`;

export const ImgDiv = styled.div`
    padding: 0 16px 0 0;
`;

export const OrderSalesMobile = styled.div`
    display: none;
    ${media.mobileDevice`    
     display: contents;
    `}
`;

export const DesktopView = styled.div`
    display: contents;
    ${media.mobileDevice`    
     display: none;
    `}
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    height: calc(100vh - 10rem - 60px);
    padding-bottom: 30px;
    box-sizing: border-box;
    ${scrollBarStyle}
    &::-webkit-scrollbar {
        display: contents;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding: 0 0 20px 0;
        margin-top: 0px;
    `}
`;

export const UndoDiv = styled.div`
    color: #1010eb;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    cursor: pointer;
    padding-right: 10px;
`;
